import colors from "../util/colors";

export default class MapaService {

    static generateRandomString(length = 26) { return Math.random().toString(36).slice(2, 2 + length); };

    static getColor(length) { return colors[length]; };

    static fitBounds(bounds) {
        let map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        map.fitBounds(bounds);
    }

    /**
     * Circle
     */
    static onCircleComplete(circle, length) {

        circle.id = this.generateRandomString();
        circle.type = "Círculo";
        circle.color = this.getColor(length);
        circle.fillColor = circle.color;

        circle.name = circle.name != undefined ? circle.name : length + 1;

        this.fitBounds(circle.getBounds());

        return circle;

    }


    /**Poligon */

    static onRectangleComplete(rectangle, length) {
        let bounds = rectangle.getBounds();
        let northEast = bounds.getNorthEast();
        let southWest = bounds.getSouthWest();

        let northWest = [northEast.lat(), southWest.lng()];
        let southEast = [southWest.lat(), northEast.lng()];

        let path = [
            [northEast.lat(), northEast.lng()],
            [northWest[0], northWest[1]],
            [southWest.lat(), southWest.lng()],
            [southEast[0], southEast[1]],
            [northEast.lat(), northEast.lng()],
        ];

        rectangle.color = rectangle.fillColor;
        rectangle.id = "retangulo-" + this.generateRandomString();

        rectangle.type = "Retângulo";
        rectangle.path = path;
        rectangle.name = rectangle.name != undefined ? rectangle.name : length + 1;

        return rectangle;

    }
    static onPolygonComplete = (polygon, length) => {
        const path = this.getPolygonPath(polygon);

        polygon.type = 'Polígono';
        polygon.id = this.generateRandomString();
        polygon.metaPath = [...path, path[0]]; 
        polygon.strokeColor = polygon.strokeColor || "#000000";
        polygon.fillOpacity = polygon.fillOpacity || 0.5;
        polygon.strokeWeight = polygon.strokeWeight || 3;
        polygon.name = polygon.name ?? length + 1;

        this.fitBounds(this.getPolygonBounds(polygon));

        return polygon;
    };


    static getPolygonPath = (polygon) => {
        if (polygon.getBounds !== undefined) {
            let bounds = polygon.getBounds();
            let northEast = bounds.getNorthEast();
            let southWest = bounds.getSouthWest();

            let northWest = [northEast.lat(), southWest.lng()];
            let southEast = [southWest.lat(), northEast.lng()];

            let path = [
                [northEast.lat(), northEast.lng()],
                [northWest[0], northWest[1]],
                [southWest.lat(), southWest.lng()],
                [southEast[0], southEast[1]],
                [northEast.lat(), northEast.lng()],
            ];

            return path;
        }

        let path = [];

        for (var i = 0; i < polygon.getPath().getLength(); i++) {
            let coordinate = polygon
                .getPath()
                .getAt(i)
                .toUrlValue(10)
                .split(",");

            path.push([Number(coordinate[0]), Number(coordinate[1])]);
        }

        return path;
    };

    static getPolygonBounds(polygon) {

        let bounds = new google.maps.LatLngBounds();

        polygon.getPaths().forEach(function (path) {
            path.forEach(function (latlng) {
                bounds.extend(latlng);
            });
        });

        return bounds;
    }



    /**
     * Funções compartilhadas
     */

    static centralizarMapaNaForma(overlay) {

        if (!overlay) return;

        if (overlay.type === 'Polígono') {
            this.fitBounds(this.getPolygonBounds(overlay));
        }

        if (overlay.type === 'Círculo' || overlay.type === 'Círculo Manual') {
            this.fitBounds(overlay.getBounds());
        }

        if (overlay.type === 'Retângulo') {
            // Pode ser um Rectangle nativo (tem getBounds) ou Polygon restaurado (sem getBounds)
            if (typeof overlay.getBounds === 'function') {
                this.fitBounds(overlay.getBounds());
            } else {
                this.fitBounds(this.getPolygonBounds(overlay));
            }
        }

    }

    static toogleOverlayVisibility(overlay) {

        if (overlay.getMap() == null) {
            overlay.setMap(window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED);
        } else {
            overlay.setMap(null);
        }
    }

    static updateShape(shape, circles, overlays) {
        for (let i = 0; i < overlays.length; i++) {
            if (overlays[i].id === shape.id) {
                overlays[i] = shape;
                overlays[i].color = shape.fillColor === "transparent" ? shape.strokeColor : shape.fillColor;
            }
        }

        if (shape.type === 'Círculo') {
            for (let i = 0; i < circles.length; i++) {
                if (circles[i].id === shape.id) {
                    circles[i] = shape;
                    circles[i].color = shape.fillColor === "transparent" ? shape.strokeColor : shape.fillColor;
                }
            }
        }

        return { overlays, circles };
    }

    static removeOverlay(id, { overlays, manualCircles, polygons }) {

        let index = overlays.findIndex((overlay) => { return overlay.id === id });

        let overlay = overlays[index];

        if (overlay.type === 'Retângulo' || overlay.type === 'Polígono') {
            let indexPoligono = polygons.findIndex((overlay) => {
                return overlay.id === id
            });
            polygons.splice(indexPoligono, 1);
            overlay.setMap(null);

        }

        if (overlay.type === 'Círculo' || overlay.type === 'Círculo Manual') {
            let indexCircle = manualCircles.findIndex((overlay) => { return overlay.id === id });
            manualCircles.splice(indexCircle, 1);


            if (overlay.setMap !== undefined) { overlay.setMap(null); }
        }

        overlays.splice(index, 1);

        return { overlays, manualCircles, polygons };

    }


}
